<template>
  <v-select
    label="Provider"
    item-text="label"
    item-value="code"
    v-model="selected"
    :items="allowedProviders"
    @change="onChange"
    :outlined="outlined"
    :hide-details="hideDetails"
    multiple
    :dense="dense"
  ></v-select>
</template>

<script>
export default {
  name: "provider-list-select",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      selected: this.value
        ? [...this.value]
        : this.$store.getters.localSettings("providerListSelectDefault", [
            "GTWEB",
          ]),
      items: [
        { label: "Local", code: "GTWEB", accessCode: "" },
        { label: "Marketplace", code: "GTWEB_MP", accessCode: "marketplace" },
        { label: "Bentral", code: "BENTRAL", accessCode: "bentral" },
        { label: "ResRequest", code: "RESREQUEST", accessCode: "resrequest" },
        { label: "Thompsons Africa", code: "THOMPSONS_AFRICA", accessCode: "thompsons_africa" },
        { label: "GTWeb External Marketplace", code: "GTWEB_EXT", accessCode: "gtweb_ext" },
      ],
    };
  },

  computed: {
    allowedProviders() {
      return this.items.filter((item) => {
        if (item.code == "GTWEB") {
          return true;
        } else {
          return this.$store.getters.hasAccessTo(
            `third_party:${item.accessCode}`,
            true
          );
        }
      });
    },
  },

  watch: {
    value(newVal) {
      // we need filter the newVal to only include the allowed providers
      const allowedProviders = this.allowedProviders.map((item) => item.code);
      this.selected = newVal
        ? newVal.filter((item) => allowedProviders.includes(item))
        : [];
    },
  },

  methods: {
    onChange(event) {
      if (event) {
        this.$emit("input", event);
      }
      this.$store.dispatch("updateLocalSettings", {
        providerListSelectDefault: this.selected,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ProviderListSelect.vue